import { CreateElement } from '@klarna-web-sdk/utils';
import { klarnaElements } from '@klarna-web-sdk/utils/src/constants';
import { MessagingEvents } from './events';
import initializeWindowInterface from './helpers/initializeWindowInterface/initializeWindowInterface';
function setupMessagingAPI() {
    const messagingEventBus = MessagingEvents.getInstance();
    const on = messagingEventBus.on.bind(messagingEventBus);
    const off = messagingEventBus.off.bind(messagingEventBus);
    const emit = messagingEventBus.emit.bind(messagingEventBus);
    initializeWindowInterface(on, off);
    const Messaging = {
        placement: (args) => {
            return new CreateElement(klarnaElements.PLACEMENT, args).getPublicAPI();
        },
        on,
        off,
        emit,
    };
    return Messaging;
}
export default setupMessagingAPI;
